export const systemItems = [
  "6 Specialized Clinical Volumes",
  "5 Exclusive Professional Bonuses",
  "12 Alopecia Conditions Covered",
  "The 15-Minute Alopecia Assessment Framework™",
  "Visual Trichoscopy References",
  "Differential Diagnosis Flowcharts",
  "Clinical Assessment Checklists",
  "Educational Clinical Cases",
];

export const specialOfferIncludes = [
  "The 15-Minute Alopecia Assessment Framework™",
  "Six specialized clinical volumes",
  "Five professional bonuses",
  "Twelve alopecia conditions",
  "Trichoscopy visual references",
  "Differential diagnosis flowcharts",
  "Clinical case studies",
  "Assessment checklists",
  "Documentation templates",
];

export const finalIncludes = [
  "The 15-Minute Alopecia Assessment Framework™",
  "Six Specialized Clinical Volumes",
  "Five Exclusive Professional Bonuses",
  "Twelve Alopecia Conditions",
  "Visual Trichoscopy References",
  "Differential Diagnosis Flowcharts",
  "Educational Clinical Cases",
  "Assessment Checklists",
  "Documentation Templates",
];

export const volumeSummary = [
  { label: "VOLUME I", title: "The 15-Minute Alopecia Assessment Framework™" },
  { label: "VOLUME II", title: "The Trichoscopy Clinical Atlas™" },
  { label: "VOLUME III", title: "The Non-Scarring Alopecia Clinical Roadmap™" },
  { label: "VOLUME IV", title: "The Scarring Alopecia Clinical Atlas™" },
  { label: "VOLUME V", title: "The Alopecia Differential Diagnosis Roadmap™" },
  { label: "VOLUME VI", title: "The Alopecia Clinical Documentation System™" },
];

export const bonusSummary = [
  { label: "BONUS #1", title: "The 100 Alopecia Clinical Cases Library™", value: 19 },
  { label: "BONUS #2", title: "The Trichoscopy Visual Master Atlas™", value: 17 },
  { label: "BONUS #3", title: "The Alopecia Differential Diagnosis Flowcharts™", value: 19 },
  { label: "BONUS #4", title: "The 15-Minute Hair Loss Assessment Toolkit™", value: 17 },
  { label: "BONUS #5", title: "The Alopecia Clinical Quick Reference Guide™", value: 19 },
];
